module.exports = __webpack_public_path__ + "img/piyao-suject-icon-left.05a5f070.png";